import { render, staticRenderFns } from "./RegisterSocial.vue?vue&type=template&id=4dc785a7&scoped=true&"
import script from "./RegisterSocial.vue?vue&type=script&lang=js&"
export * from "./RegisterSocial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc785a7",
  null
  
)

export default component.exports